import { render, staticRenderFns } from "./LedgerSummary.vue?vue&type=template&id=30154922"
import script from "./LedgerSummary.vue?vue&type=script&lang=js"
export * from "./LedgerSummary.vue?vue&type=script&lang=js"
import style0 from "./LedgerSummary.vue?vue&type=style&index=0&id=30154922&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports